<template>
  <div class="loader-svg" crm_at="loading_logo" :class="{ loaded: !isShow }">
    <img src="@/assets/images/loading.svg" alt="" />
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    isShow: Boolean,
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/_mixin.scss';
.loader-svg {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($color-white, 0.8);
  z-index: 99999;
  &.loaded {
    display: none;
  }
  img {
    margin: auto;
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
  }
}
</style>
